// extracted by mini-css-extract-plugin
module.exports = {"img":"ProductCard_img_ldFZI","name":"ProductCard_name_1k8Kr","disc":"ProductCard_disc_2iQGX","map":"ProductCard_map_JSHaS","price":"ProductCard_price_3cWw5"};